export const indicatorStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  position: 'absolute',
  top: '-10px',
  right: '8px',
  zIndex: 1,
  backgroundColor: ({ palette }) => palette.background.paper,
  padding: '0 4px',
  borderRadius: '4px',
};

export const getLockIconColorStyles = userColor => ({
  color: userColor || (({ palette }) => palette.warning.main),
  display: 'flex',
  alignItems: 'center',
});

const displayNameStyles = {
  maxWidth: '120px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getDisplayNameColorStyles = userColor => ({
  ...displayNameStyles,
  color: userColor || 'warning.dark',
});
